import { gql } from '@apollo/client/core';

export const getControllerNoteHistories = gql`
  query getControllerNoteHistories($id: String, $parentId: String) {
    getControllerNoteHistories(id: $id, parentId: $parentId) {
      id
      parentId
      timestamp
      user
      note
    }
  }
`;
